/* src/app/components/mobile-toolbar/mobile-toolbar.component.scss */
ion-toolbar {
  --background: black;
  height: 85px;
  display: flex;
  align-items: center;
}
ion-toolbar ion-button {
  height: 65px;
  width: 55px;
}
ion-toolbar ion-button:hover {
  opacity: 1 !important;
}
ion-toolbar ion-button:hover ion-icon,
ion-toolbar ion-button:hover span,
ion-toolbar ion-button:hover ion-label {
  color: var(--ion-color-secondary) !important;
}
ion-toolbar ion-button:hover svg {
  fill: var(--ion-color-secondary) !important;
}
.burger-menu-icon {
  width: 30px;
  fill: white;
}
ion-title {
  width: fit-content;
  padding: 0;
}
ion-title:nth-of-type(2) {
  padding: 0;
  color: white;
  left: 50%;
  transform: translateX(-50%);
}
.shoppingCartIcon {
  width: 30px !important;
  height: 30px !important;
}
.toolbar-container {
  height: 100%;
}
ion-toolbar ion-badge {
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 0;
}
/*# sourceMappingURL=mobile-toolbar.component-5JVVBCZI.css.map */
